import React, { memo, useState } from 'react';
import {
    withErrorProvider,
    withErrorProviderPropTypes,
    withLoaderProvider,
    withLoaderStatePropTypes,
} from '@paysera/react-common';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SubmissionError } from 'redux-form';

import { RECIPIENTS, BASE_CONTACTUS_MESSAGE_SUBJECT } from '../config/constants';
import ContactUsForm from './ContactUsForm';
import useSendContactForm from '../hooks/useSendContactForm';
import prepareServerValidationError from '../services/prepareServerValidationError';
import prepareAttachments from '../services/prepareAttachments';

const ContactUs = ({
    recipient,
    loaderHandler,
    errorHandler,
}) => {
    const { t } = useTranslation('PayseraContactFormBundle');
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const onSuccess = () => setShowSuccessAlert(true);
    const onError = (errors) => {
        throw new SubmissionError(prepareServerValidationError(errors));
    };

    const handleSubmit = async ({
        name,
        email,
        product,
        message,
        companyName,
        attachments,
    }) => {
        const requestObject = {
            name,
            email,
            subject: `${BASE_CONTACTUS_MESSAGE_SUBJECT} ${companyName} - ${product}`,
            message,
            recipient,
            attachments: prepareAttachments(attachments || []),
        };

        await useSendContactForm(requestObject, loaderHandler, errorHandler, onSuccess, onError, t);
    };

    const getDescription = () => (recipient === RECIPIENTS.support ? t('contact_form.description.type_support') : '');

    if (showSuccessAlert) {
        return (
            <Alert bsStyle="success">
                {t('contact_form.sent_successfully')}
            </Alert>
        );
    }

    return (
        <>
            <p>{getDescription()}</p>
            <ContactUsForm
                onSubmit={handleSubmit}
                onError={onError}
                requestErrors={errorHandler}
            />
        </>
    );
};

ContactUs.propTypes = {
    recipient: PropTypes.string.isRequired,
    ...withLoaderStatePropTypes,
    ...withErrorProviderPropTypes,
};

export default compose(
    memo,
    withErrorProvider,
    withLoaderProvider,
)(ContactUs);
